import config from "./Config.ts";

function environment() {
  return config.isDev() ? "dev" : "prod";
}

export function resourceGroup(appName: string) {
  const env = environment();
  return `${env}-marked-${appName}`;
}

// "/subscriptions/6f8b93b9-0fc0-496c-baf2-39c9588a5432/resourcegroups/prod-marked-uc-eventconsumer/providers/microsoft.web/sites/prod-marked-uc-eventconsumer-app"
// -> uc-eventconsumer
export function extractApp(resourceId: string) {
  const split = resourceId.split("/");
  const applicationId = split[split.length - 1];
  return applicationId
    .replace(`${environment()}-marked-`, "")
    .replace("-app", "");
}

export class App {
  readonly name: string;
  readonly hostname: string;
  readonly logsUrl: string;
  readonly slot: slot;

  constructor(
    name: string,
    hostname: string,
    logsUrl: string,
    slot: slot = "prod"
  ) {
    this.name = name;
    this.hostname = hostname;
    this.logsUrl = logsUrl;
    this.slot = slot;
  }
  appId() {
    return `${this.name}${this.slot == "staging" ? "-staging" : ""}`;
  }
}

export type slot = "staging" | "prod";

const appsWithStaging = [
  "bp-api",
  "mittnte-adminapi",
  "mittnte-api",
  "strombestilling-api",
];
const appsInOnlyDev = config.isDev() ? ["elhub-simulator"] : [];
const appsWithoutStaging = [
  'law-slack',
  "nordpool-dayahead-import",
  "uc-meteringvalues",
  "uc-eventconsumer",
  "utilitycloud-proxy",
].concat(appsInOnlyDev);
const markedApplicationsNames = appsWithStaging.concat(appsWithoutStaging);

export const markedApplications = markedApplicationsNames
  .sort()
  .flatMap((name) => {
    const apps = [
      new App(
        name,
        `${name}.marked.azure.nte.${config.isDev() ? "dev" : "no"}`,
        LAWUrl(config.subscriptionId, resourceGroup(name))
      ),
    ];
    if (environment() == "prod" && appsWithStaging.includes(name)) {
      return apps.concat(
        new App(
          name,
          `${name}.marked.azure.nte.${config.isDev() ? "dev" : "no"}`,
          LAWUrl(config.subscriptionId, resourceGroup(name), "staging"),
          "staging"
        )
      );
    } else {
      return apps;
    }
  });

function LAWUrl(
  subscriptionId: string,
  resourceGroup: string,
  slot: slot = "prod"
): string {
  const slotPath = slot == "prod" ? "" : `/slots/${slot}`;
  return `https://portal.azure.com/#@nteholding.onmicrosoft.com/resource/subscriptions/${subscriptionId}/resourceGroups/${resourceGroup}/providers/Microsoft.Web/sites/${resourceGroup}-app${slotPath}/analytics`;
}
